import React from 'react';
import ReactDOMClient from 'react-dom/client';
import MemberForm from './member-form.jsx';
import numberWithCommas from './number-with-commas.jsx';
import PaymentForm from './payment-form.jsx';

function once(fn, context) { 
  var result;
  return function() { 
      if (fn) {
          result = fn.apply(context || this, arguments);
          fn = null;
      }
      return result;
  };
}

function round(num) {
  return (Math.round(parseFloat(num.toFixed(3)) * 100) / 100).toFixed(2);
}

var $ = jQuery;
var apiURL = 'https://htv.emoney.com/v3/adapters';
var apiKey = '';
var apiToken;
var nodeURL;
var membershipData = [];
var memberHash;
var signaturePad;
var renewal_period = null;
var planIsBusiness = false;
var planPrice = 0;
var finalPrice = 0;
var subtotalPrice = 0;
var additionalsCount = 0;
var discountsPrice = 0.00;
var renewal_discount = 0;
var validators = [];
var paymentProcessed = false;
var captchaExecuted = false; // toggle to test
if (String(document.location).indexOf('localhost') !== -1) {
  // captchaExecuted = true;
}
// captcha is not really working on Safari since latest updates in 2022
if (String(navigator.vendor).indexOf('Apple Computer, Inc.') !== -1) {
  captchaExecuted = true;
}
var isDone = true;
var transactionId;
var correlationId;
var approvalCode;
var $member_id = null;
var $member_zipcode = null;
var generateSessionId = function() {
  return String((new Date()).getTime()).substring(0, 5);
}
var session = generateSessionId();
var before121 = (new Date()).getTime() < (new Date(2023, 11, 1)).getTime();
var isExistingMember = $('.js-existing-member:checked').val() === '1';

function log(message) {
  console.log(session + ' - ' + message);
  if (typeof Sentry === 'object') {
    Sentry.captureMessage(session + ' - ' + message);
  }
}
function onSubmitMemberForm() {
  captchaExecuted = true;
  isDone = false;
  
  // validate Date of Birth to be under 35 years
  if ($("#ma-date-of-birth").is(':visible')) {
    var valid_dob = false;
    var year = $('#member_birthday_year').val();
    var month = $('#member_birthday_month').val();
    var day = $('#member_birthday_day').val();
    var member_birthdate = new Date(year, month-1, day);

     // he has to be at most 35 years old and his next birthday has to be tomorrow or later
    var now = new Date();

    // if (now.getFullYear() - member_birthdate.getFullYear() <= 35) {
    //   valid_dob = true;
    // } else if (now.getFullYear() - member_birthdate.getFullYear() === 36) {
    //   if (now.getMonth() < member_birthdate.getMonth()) {
    //     valid_dob = true;
    //   } else if (now.getMonth() === member_birthdate.getMonth()) {
    //     if (now.getDate() < member_birthdate.getDate()) {
    //       valid_dob = true;
    //     }
    //   }
    // }

    // if (!valid_dob) {
    //   setTimeout(function() {
    //     $('#ma-date-of-birth-error').remove();
    //     var error = '<label id="ma-date-of-birth-error" class="error" style="display: block;">You have to be 35 or under<br />to be eligible to apply for this membership plan.</label>';
    //     $('#ma-date-of-birth .form-group').append(error);  
    //   }, 1);
    //   return false;
    // } else {
    //   $('#ma-date-of-birth-error').remove();
    // }
  }

  jQuery('#ma-member').removeClass('is-active');
  jQuery('#ma-payment').addClass('is-active');

  $('form.checkout').off('submit.membership'); // disable the disabling

  // show Young Pro Terms of usage
  if (jQuery('#ma-member input[name="member[plan]"]').val().toLowerCase().indexOf('young pro') !== -1) {
    jQuery('#ma-terms-young-pro').addClass('is-active');
    jQuery('#ma-terms-young-pro').find('[data-required]').prop('required', true);
  }
  // transfer billing info data from page 1 member data
  if (!$('#payment_billing_info_first_name').val()) {
    $('#payment_billing_info_first_name').val($('#member_first_name').val());
  }
  if (!$('#payment_billing_info_middle_name').val()) {
    $('#payment_billing_info_middle_name').val($('#member_middle_name').val());
  }
  if (!$('#payment_billing_info_last_name').val()) {
    $('#payment_billing_info_last_name').val($('#member_last_name').val());
  }
  if (!$('#payment_billing_info_address').val()) {
    $('#payment_billing_info_address').val($('#member_address').val());
  }
  if (!$('#payment_billing_info_city').val()) {
    $('#payment_billing_info_city').val($('#member_city').val());
  }
  if (!$('#payment_billing_info_state').val()) {
    $('#payment_billing_info_state').val($('#member_state').val());
  }
  if (!$('#payment_billing_info_zipcode').val()) {
    $('#payment_billing_info_zipcode').val($('#member_zipcode').val());
  }
  // transfer charging account info data from page 1 member data
  if (!$('#payment_charging_account_first_name').val()) {
    $('#payment_charging_account_first_name').val($('#member_first_name').val());
  }
  if (!$('#payment_charging_account_middle_name').val()) {
    $('#payment_charging_account_middle_name').val($('#member_middle_name').val());
  }
  if (!$('#payment_charging_account_last_name').val()) {
    $('#payment_charging_account_last_name').val($('#member_last_name').val());
  }
  if (!$('#payment_charging_account_address').val()) {
    $('#payment_charging_account_address').val($('#member_address').val());
  }
  if (!$('#payment_charging_account_city').val()) {
    $('#payment_charging_account_city').val($('#member_city').val());
  }
  if (!$('#payment_charging_account_state').val()) {
    $('#payment_charging_account_state').val($('#member_state').val());
  }
  if (!$('#payment_charging_account_zipcode').val()) {
    $('#payment_charging_account_zipcode').val($('#member_zipcode').val());
  }
}
// important for ReCaptcha to know about the function 
window.onSubmitMemberForm = onSubmitMemberForm;

// disable manual form submission of this WooCommerce Product
$('form.checkout').on('submit.membership', function(e) {
  return false;
});

/**
 * Display error
 * 
 * @param {object} response 
 * @param {string} type - type of payment
 */
function showError(response, type) {
  var errorTitle = 'Error';
  var errorMessage = 'An error ocurred while processing your payment. Please contact support.';
  if (response.responseJSON) {
    errorMessage = response.responseJSON.error.description;
    if (errorMessage.indexOf('not a valid credit card number') > -1) {
      if (type == 'payment') {
        errorMessage = 'The Payment Credit Card Number is not valid.';
      } else if (type == 'charging_account') {
        errorMessage = 'The Charging Account Credit Card Number is not valid.';
      }
    } else if (errorMessage.indexOf('NameOnCard field is required') > -1) {
      if (type == 'payment') {
        errorMessage = 'The Payment Credit Card Holder Name is required.';
      } else if (type == 'charging_account') {
        errorMessage = 'The Charging Account Credit Card Holder Name is required.';
      }
    } else if (errorMessage.indexOf('DUPLICATE TRANS') > -1) {
      errorMessage = 'Duplicate transaction identified. Please contact support.';
    } else if (errorMessage.indexOf('The Token field is required') > -1) {
      errorMessage = 'An error ocurred while processing your payment. Please contact support.';
    } else if (errorMessage.indexOf('DECLINE') > -1) {
      errorMessage = 'Your payment has been declined. Please try again or contact your credit card issuer.';
    } else if (errorMessage.indexOf('HOLD-CALL') > -1) {
      errorMessage = 'Your payment has been declined. Please try again or contact your credit card issuer.';
    } else {
      if (type == 'charging_account') {
        errorTitle = errorTitle + ' - Charging Account';
      }
      errorMessage = response.responseJSON.error.description;
      if (errorMessage && errorMessage.match && errorMessage.match('session ID')) {
        errorMessage += '. Please, try again.';
      }
    }
  }
  swal(
    errorTitle,
    errorMessage,
    'error'
  );
  console.log(response);
}

// function processPayment(response) {
//   var instrumentId = response.createPaymentInstrumentResponse.instrumentId;
//   correlationId = memberHash;
//   log('processPayment start: ' + JSON.stringify(response));
//   return jQuery.ajax({
//     url: apiURL + "?dt=" + new Date().getTime(),
//     method: 'post',
//     dataType: "json",
//     contentType: "application/json",
//     crossDomain: true,
//     data: JSON.stringify({
//       charge: {
//         chargeRequest: {
//           token: apiToken,
//           amount: finalPrice,
//           entryType: "KEYED_CARD_NOT_PRESENT",
//           instrumentId: instrumentId,
//           correlationId: correlationId
//         }
//       },
//     })
//   }).success(function (response) {
//     log('processPayment success: ' + JSON.stringify(response));
//     if (response.chargeResponse) {
//       transactionId = response.chargeResponse.transactionId;
//       approvalCode = response.chargeResponse.approvalCode;
//       if (response.chargeResponse.payment) {
//         var status = response.chargeResponse.payment.status;
//         if (status == "Completed") {
//           // swal(
//           //     'Payment Success',
//           //     'Your payment has been approved.',
//           //     'success'
//           // );
//           membershipData = jQuery('#ma-member-form').closest('form').serializeArray();
//           membershipData.push({
//             name: 'payment[transactionId]',
//             value: transactionId
//           });
//           membershipData.push({
//             name: 'payment[correlationId]',
//             value: correlationId
//           });
//           membershipData.push({
//             name: 'payment[approvalCode]',
//             value: approvalCode
//           });
//           membershipData.push({
//             name: 'member[plan_price]',
//             value: finalPrice
//           });
//           membershipData.push({
//             name: 'member[signature]',
//             value: signaturePad.toDataURL()
//           });
//           membershipData.push({
//             name: 'member[hash]',
//             value: memberHash
//           });
//           paymentProcessed = true;
//           isDone = true;
//         } else {
//           showError(response, 'payment');
//         }
//       } else {
//         swal(
//           'Error',
//           'Selected plan doesn not have a valid price.',
//           'error'
//         );
//         jQuery('#ma-payment-form .button-continue').removeClass('is-loading');
//         jQuery('#ma-payment-form .button-continue').prop('disabled', false);
//         jQuery('#ma-payment-form .button-back').prop('disabled', false);
//       }
//     } else {
//       jQuery('#ma-payment-form .button-continue').removeClass('is-loading');
//       jQuery('#ma-payment-form .button-continue').prop('disabled', false);
//       jQuery('#ma-payment-form .button-back').prop('disabled', false);
//     }
//   }).error(function (response) {
//     log('processPayment error: ' + JSON.stringify(response));
//     showError(response, 'payment');
//     jQuery('#ma-payment-form .button-continue').removeClass('is-loading');
//     jQuery('#ma-payment-form .button-continue').prop('disabled', false);
//     jQuery('#ma-payment-form .button-back').prop('disabled', false);
//     initApiToken(); // reinitialize API token
//   });
// }

function processPayment(response) {
  // var instrumentId = response.createPaymentInstrumentResponse.instrumentId;
  correlationId = memberHash;
  transactionId = '';//response.chargeResponse.transactionId;
  approvalCode = '';//response.chargeResponse.approvalCode;
  membershipData = jQuery('#ma-member-form').closest('form').serializeArray();
  membershipData.push({
    name: 'payment[transactionId]',
    value: transactionId
  });
  membershipData.push({
    name: 'payment[correlationId]',
    value: correlationId
  });
  membershipData.push({
    name: 'payment[approvalCode]',
    value: approvalCode
  });
  membershipData.push({
    name: 'member[plan_price_notax]',
    value: subtotalPrice
  });
  membershipData.push({
    name: 'member[plan_price]',
    value: finalPrice
  });
  membershipData.push({
    name: 'member[signature]',
    value: signaturePad.toDataURL()
  });
  membershipData.push({
    name: 'member[hash]',
    value: memberHash
  });
  // membershipData.push({
  //   name: 'member[has_charging_account]',
  //   value: '1'
  // });
  paymentProcessed = true;
  isDone = true;
  return true;
}

function processSignature() {
  membershipData.push({
    name: 'member[plan_price]',
    value: finalPrice
  });
  membershipData.push({
    name: 'member[signature]',
    value: signaturePad.toDataURL()
  });
}

// function initApiToken() {
//   $.ajax({
//     url: apiURL + "?dt=" + new Date().getTime(),
//     method: 'post',
//     dataType: "json",
//     contentType: "application/json",
//     crossDomain: true,
//     data: JSON.stringify({
//       signIn: {
//         signInRequest: {
//           apiKey: apiKey
//           // apiKey: "1231231-1233-45BE-911C-1321312321312"
//         }
//       }
//     })
//   }).success(function (response) {
//     if (response.signInResponse) {
//       apiToken = response.signInResponse.token;
//     }
//   }).error(function (response) {
//     log('error doing signIn: ' + JSON.stringify(response));
//   });
// }

function initApiToken() {
  apiToken = '';
}

window.onbeforeunload = function () {
  if (!isDone) {
    return "Membership process has not been finalized yet.";
  } else {
    return;
  }
};


var renewalAjax = null;
var renewalLastMemberId = null;
var renewalLastZipcode = null;

var init = function() {
  // log('init called');
  
  jQuery('#ma-member').addClass('is-active');
  jQuery('#ma-payment').removeClass('is-active');

  // this. will point to Membership instance
  $('[data-toggle="tooltip"]').tooltip();
  var canvasSignature = document.getElementById("signature");
  try {
    signaturePad = new SignaturePad(canvasSignature, {
      onEnd: function () {
        // jQuery('.test-signature').attr('src', signaturePad.toDataURL());
      }
    });
  } catch(e) {
    console.error(e.stack);
  }
  
  $('.js-clear-signature').click(function () {
    signaturePad.clear();
    return false;
  });
  $('.phone_us').mask('(000) 000-0000');
  
  initApiToken();

  // important for Validator initialization
  $('form.checkout').validate();

  function validateChargingAccount(mainResponse) {
    var $creditCardNumber = jQuery('#payment_charging_account_cc_number');
    var $creditCardExpMonth = jQuery('#payment_charging_account_cc_exp_month');
    var $creditCardExpYear = jQuery('#payment_charging_account_cc_exp_year');
    var $creditCardCode = jQuery('#payment_charging_account_cc_code');
    var billingFullName = jQuery('#payment_charging_account_first_name').val() + ' ' +
      jQuery('#payment_charging_account_middle_name').val() + ' ' +
      jQuery('#payment_charging_account_last_name').val();
    var $billingAddress = jQuery('#payment_charging_account_address');
    var $billingZipCode = jQuery('#payment_charging_account_zipcode');
    var chargingAccountInfo = {
      token: apiToken,
      name: billingFullName + ' CC - Charging Account',
      properties: {
        nameOnCard: billingFullName,
        cardNumber: $creditCardNumber.val(),
        expirationDate: $creditCardExpMonth.val() + '/' + $creditCardExpYear.val(),
        cvv: $creditCardCode.val(),
      },
      billingAddress: {
        addressLine1: $billingAddress.val(),
        postalCode: $billingZipCode.val()
      }
    };
    processPayment(mainResponse);
    // jQuery.ajax({
    //   url: apiURL + "?dt=" + new Date().getTime(),
    //   method: 'post',
    //   dataType: "json",
    //   contentType: "application/json",
    //   crossDomain: true,
    //   data: JSON.stringify({
    //     createPaymentInstrument: {
    //       createPaymentInstrumentRequest: chargingAccountInfo
    //     }
    //   })
    // }).success(function (response) {
    //   if (response.createPaymentInstrumentResponse) {
    //     // Chargin Account Validation
    //     processPayment(mainResponse);
    //   }
    // }).error(function (response) {
    //   showError(response, 'charging_account');
    //   jQuery('#ma-payment-form .button-continue').removeClass('is-loading');
    //   jQuery('#ma-payment-form .button-continue').prop('disabled', false);
    //   jQuery('#ma-payment-form .button-back').prop('disabled', false);
    // });
  }

  // Back action
  jQuery('.js-back').click(function () {
    var $activeSection = jQuery('.membership-app-section.is-active');
    if ($activeSection.attr('id') == 'ma-payment') {
      $activeSection.removeClass('is-active');
      jQuery('#ma-member').addClass('is-active');
    }
  });

  function changeExistingMember(checked) {
    isExistingMember = checked;
    updatePlanPrice();
  }

  // Clicked yes/no on Spouses / Children
  function changeAdditionalInfo(checked) {
    if ($('#ma-member-info:visible').length) {
      var $blocks = jQuery('#ma-additional-info');
      if (checked) {
        $blocks.addClass('is-active');
        $blocks.find('[data-required]').prop('required', true);
        if (additionalsCount == 0) {
          additionalsCount++;
        }
      } else {
        $blocks.removeClass('is-active');
        $blocks.find('[data-required]').prop('required', false);
      }
    }
    trackAdditional();

    if (jQuery('#ma-member-info:visible').length) {
      var $blocks = jQuery('#ma-additional-access-option');
      if (checked) {
        $blocks.addClass('is-active');
        $blocks.find('[data-required]').prop('required', true);
      } else {
        $blocks.removeClass('is-active');
        $blocks.find('[data-required]').prop('required', false);
      }
    }
    jQuery('.js-additional-access-option').off('change.spousechild').on('change.spousechild', function() {
      updatePlanPrice();
    });
    updatePlanPrice();
  }

  // Toggle "existing member"
  jQuery('.js-existing-member').click(function () {
    var $checked = jQuery('.js-existing-member:checked');
    changeExistingMember($checked.val() === '1');
  });

  // Toggle Additional Info
  jQuery('.js-has-additional').click(function () {
    var $checked = jQuery('.js-has-additional:checked');
    updatePlan();
    changeAdditionalInfo($checked.val() == 1);
  });
  // Track additional Spouse/Child switch
  function trackAdditional() {
    jQuery('.additionals-table select.adt-relationship').off('change.spousechild').on('change.spousechild', function() {
      updatePlanPrice();
    });
  }

  // Add Additional
  function addAdditional() {
    var $tableBody = jQuery('.additionals-table tbody');
    var templateHtml = $tableBody.find('tr[data-id="0"]')[0].outerHTML;
    var uniqueID = Math.floor(1000 + Math.random() * 9000);
    templateHtml = templateHtml.replace(/\[0\]/g, "[" + uniqueID + "]");
    templateHtml = templateHtml.replace(/\_0/g, "_" + uniqueID);
    templateHtml = templateHtml.replace(/\"0\"/g, '"' + uniqueID + '"');
    var $newRow = jQuery(templateHtml);
    $newRow.find('select,input').val("");
    $tableBody.append($newRow);
    trackAdditional();
    jQuery('.phone_us').mask('(000) 000-0000');
    if ($tableBody.find('tr').length >= 3) {
      $('.js-add-additional').addClass('hidden-block');
    }
  }
  jQuery('.js-add-additional').click(function () {
    addAdditional();
    additionalsCount++;
    updatePlanPrice();
  });
  jQuery('.js-add-additional-members').click(function () {
    var qty = parseInt(jQuery(this).data('qty'));
    var price = parseFloat(jQuery(this).data('price'));
    for (var i = 0; i < qty; i++) {
      addAdditional();
    }
    updatePlanPrice();
    jQuery('.js-add-additional-members').hide();
    jQuery('.js-remove-additional-members').show();
  });
  jQuery('.js-remove-additional-members').click(function () {
    var i = 0;
    jQuery('.additionals-row').each(function () {
      if (i > 14) {
        jQuery(this).remove();
      }
      i++;
    });
    updatePlanPrice();
    jQuery('.js-add-additional-members').show();
    jQuery('.js-remove-additional-members').hide();
  });
  // Remove Additional
  function removeAllAdditionals() {
    jQuery('.js-remove-additional').each(function () {
      var $this = jQuery(this);
      var itemID = parseInt($this.data('id'));
      removeAdditional(itemID);
    });
  }
  function removeAdditional(itemID) {
    var $tableBody = jQuery('.additionals-table tbody');
    var $target = jQuery('.additionals-row[data-id="' + itemID + '"]');
    if (itemID == 0) {
      $target.find('select,input').val('');
    } else {
      $target.remove();
      additionalsCount--;
    }
    updatePlanPrice();

    if ($tableBody.find('tr').length < 3) {
      $('.js-add-additional').removeClass('hidden-block');
    }
  }
  jQuery(document).on('click', '.js-remove-additional', function () {
    var $this = jQuery(this);
    var itemID = parseInt($this.data('id'));
    swal({
      title: 'Do you confirm the removal?',
      type: 'question',
      showCancelButton: true,
    }).then(function (result) {
      if (result.value) {
        removeAdditional(itemID);
      }
    });
  });

  // Toggle Cart Pass
  let toggleCartPass = function() {
    updatePlanPrice();
  }

  $('.js-cart-pass').on('click', function() {
    toggleCartPass();
  });

  // Toggle Charging Account
  let toggleChargingAccount = function () {
    var $checked = jQuery('.js-has-charging-account:checked').val();
    var $blocks = jQuery('#ma-ez-pay,#ma-terms-charging-account,#ma-payment-charging-account');
    var $fields = jQuery('#ma-ez-pay,#ma-terms-charging-account').find('[data-required]');
    if ($checked === '1') {
      $blocks.addClass('is-active');
      $fields.prop('required', true);
    } else {
      $blocks.removeClass('is-active');
      $fields.prop('required', false);
    }
  };

  // Toggle for "Same card for monthly payments"
  let toggleMonthlyPayments = () => {
    var $checked = $('.js-payment-method:checked');
    if ($checked.val() === 'monthly') {
      $('#ma-same-credit-card-for-monthly-payments').removeClass('hidden');
      $('#ma-same-credit-card-for-monthly-payments [data-required]').prop('required', true);
    } else {
      $('#ma-same-credit-card-for-monthly-payments').addClass('hidden');
      $('#ma-same-credit-card-for-monthly-payments [data-required]').prop('required', false);
    }

    // console.log($('.js-has-charging-account:checked').val(), $checked.val());

    var $samecard = $('.js-same-card-for-monthly-payments:checked');
    var $blocks = $('#ma-payment-monthly-info');
    var $fields = $('#ma-same-credit-card-for-monthly-payments').find('[data-required]');
    
    if ($('.js-has-charging-account:checked').val() === '0' && $checked.val() === 'monthly') {
      // however, when no Charging Account selected and Monthly Payments is selected, we NEED to fill it
      $blocks.removeClass('hidden');
      $fields.prop('required', true);
      $('#ma-same-credit-card-for-monthly-payments > .form-group-wrap').addClass('hidden');
      $('#ma-same-credit-card-for-monthly-payments [data-required]').prop('required', true);
      $('#same_card_for_monthly_payments_no').prop('checked', true);
      return;
    } else {
      $('#ma-same-credit-card-for-monthly-payments > .form-group-wrap').removeClass('hidden');
    }

    if ($('.js-has-charging-account:checked').val() === '1' && $checked.val() === 'monthly') {
      this.setState({
        require_same_credit_card_checkbox: true
      });
    } else {
      this.setState({
        require_same_credit_card_checkbox: false
      });
    }

    if ($samecard.val() === '') {
      $blocks.removeClass('hidden');
      $fields.prop('required', true);
    } else {
      $blocks.addClass('hidden');
      $fields.prop('required', false);
    }
  };

  $('.js-has-charging-account').on('click', function () {
    toggleChargingAccount();
    toggleMonthlyPayments();
  });

  toggleChargingAccount();

  $('.js-same-card-for-monthly-payments').on('click', function() {
    toggleMonthlyPayments();
  });

  toggleMonthlyPayments();

  // Toggle Payment Method
  jQuery('.js-payment-method').click(function () {
    var $checked = jQuery('.js-payment-method:checked');
    var $payment_method_cc_details = jQuery('#ma-payment-method-cc');
    var $blocksskip = jQuery('#ma-payment-method-skip');
    var $fields = $payment_method_cc_details.find('#payment_cc_number,#payment_cc_code,#payment_cc_exp_month,#payment_cc_exp_year');
    if ($checked.val() == 'credit_card') {
      $payment_method_cc_details.addClass('is-active');
      $blocksskip.removeClass('is-active');
      $fields.prop('required', true);
    } else if ($checked.val() === 'skip') {
      $payment_method_cc_details.removeClass('is-active');
      $blocksskip.addClass('is-active');
      $fields.prop('required', false);
      // show credit card info if Skip + Credit Card
      jQuery('input[name="payment[payment_type]"]:checked').trigger('change');
    } else {
      $payment_method_cc_details.removeClass('is-active');
      $blocksskip.removeClass('is-active');
      $fields.prop('required', false);
    }
    toggleMonthlyPayments();
  });
  
  // Toggle skip payment method and select credit card
  jQuery('input[name="payment[payment_type]"]').change(function() {
    var val = $('input[name="payment[payment_type]"]:checked').val();
    var $payment_method_cc_details = jQuery('#ma-payment-method-cc');
    var $fields = $payment_method_cc_details.find('#payment_cc_number,#payment_cc_code,#payment_cc_exp_month,#payment_cc_exp_year');
    if (val === 'Credit Card') {
      $payment_method_cc_details.addClass('is-active');
      $fields.prop('required', true);
    } else {
      $payment_method_cc_details.removeClass('is-active');
      $fields.prop('required', false);
    }
  });

  // Toggle Partial Payment inputs
  jQuery('.js-partial-payment').change(function () {
    var $checked = jQuery('.js-partial-payment:checked');
    var $blocks = $checked.closest('label').nextAll('.inputs');
    var $fields = $blocks.find('input,select,textarea');
    if ($checked.val() == 'partial') {
      $blocks.addClass('is-active');
      $fields.prop('required', true);
    } else {
      $blocks.removeClass('is-active');
      $fields.prop('required', false);
    }
  });
  // Toggle Payment Different Info
  jQuery('.js-payment-different-info').click(function () {
    var $checked = jQuery('.js-payment-different-info:checked');
    var $blocks = jQuery('#ma-payment-different-info');
    if ($checked.val() == 1) {
      $blocks.addClass('is-active');
      $blocks.find('[data-required]').prop('required', true);
    } else {
      $blocks.removeClass('is-active');
      $blocks.find('[data-required]').prop('required', false);
    }
  });

  // Toggle Payment CA Different Info
  let togglePaymentChargingAccountDifferentInfo = function () {
    var $checked = true; //jQuery('.js-payment-charging-account-different-info:checked');
    var $blocks = jQuery('#ma-payment-charging-account-info');
    if ($checked) {
      $blocks.addClass('is-active');
      $blocks.find('[data-required]').prop('required', true);
    } else {
      $blocks.removeClass('is-active');
      $blocks.find('[data-required]').prop('required', false);
    }
  };

  togglePaymentChargingAccountDifferentInfo();
  // jQuery('.js-payment-charging-account-different-info').on('click', togglePaymentChargingAccountDifferentInfo);

  // Renewal
  var validateRenewalInfo = () => {
    $member_id = jQuery('#renewal_member_id');
    $member_zipcode = jQuery('#renewal_member_zipcode');
    if ($member_id.val().length == 5 && $member_zipcode.val().length == 5) {
      // multiple things to avoid multiple ajax calls
      // don't load the same request if it's the same member id and zipcode
      if ($member_id.val() !== renewalLastMemberId || $member_zipcode.val() !== renewalLastZipcode) {
        if (renewalAjax && renewalAjax.abort) {
          renewalAjax.abort();
        }
        renewalAjax = loadMemberInfo($member_id.val(), $member_zipcode.val());
        renewalLastMemberId = $member_id.val();
        renewalLastZipcode = $member_zipcode.val();
      }
    }
  }

  var loadMemberInfo = (member_id, member_zipcode, callback) => {
    log('loading member info ' + member_id + ' - ' + member_zipcode);
    jQuery('#ma-member-form .form-actions .button-continue').addClass('is-loading');
    this.setState({ member_loaded: false });
    return jQuery.ajax({
      url: nodeURL + '?renewal_info=1&mid=' + member_id + '&zipcode=' + member_zipcode,
      method: 'get',
      dataType: 'json'
    }).success((response) => {
      if (response != 'false' && response) {
        this.setState({ member_loaded: true });
        jQuery('#member_first_name').val(response.first_name);
        jQuery('#member_last_name').val(response.last_name);
        jQuery('#member_address').val(response.address);
        jQuery('#member_city').val(response.city);
        jQuery('#member_state').val(response.state);
        jQuery('#member_zipcode').val(response.zipcode);
        jQuery('#member_phone').val(response.phone);
        jQuery('#member_email').val(response.email);
        if (response.home_club) {
          jQuery('#home_club_' + response.home_club).prop('checked', true).trigger('change');
        }
        if (response.additional > 0 && response.additionals.length > 0) {
          removeAllAdditionals();
          jQuery('#additional_yes').trigger('click');
          var $blocks = jQuery('#ma-additional-info');
          $blocks.addClass('is-active');
          $blocks.find('[data-required]').prop('required', true);
          for (var i = 0; i < (response.additionals.length - 1); i++) {
            jQuery('.js-add-additional').trigger('click');
          }
          var $items = jQuery('.additionals-row');
          var index = 0;
          $items.each(function () {
            var $item = jQuery(this);
            var additional = response.additionals[index];
            $item.find('.adt-name').val(additional.name);
            $item.find('.adt-email').val(additional.email);
            $item.find('.adt-relationship').val(additional.relationship);
            $item.find('.adt-birthday-month').val(additional.birthday.month);
            $item.find('.adt-birthday-day').val(additional.birthday.day);
            $item.find('.adt-birthday-year').val(additional.birthday.year);
            index++;
          });
        }
        if (response.plan) {
          jQuery('[name="member[plan_nid]"]').val(response.plan.id);
          jQuery('[name="member[plan]"]').val(response.plan.name);
          planIsBusiness = (response.plan.is_business_plan == 'yes' || response.plan.is_business_plan == 1);
          updatePlan();
          jQuery('.plan-name').html(response.plan.name);
          // jQuery('.plan-price').html(response.plan.label_final_price);
          // jQuery('#ma-member .plan-price').html(response.plan.label_split_price);
          planPrice = parseFloat(response.plan.price);
          discountsPrice = parseFloat(response.plan.discounts_price);
          finalPrice = parseFloat(response.plan.final_price);
          this.setState({
            tax_rate: response.plan.tax_rate,
            taxable_amount: response.plan.taxable_amount
          }, () => {
            updatePlanPrice();
          });
        }
        if (jQuery('#member_zipcode').val() !== '00000' && ((response.payment_transaction_id && response.payment_approval_code) || response['renewed_' + renewal_period])) {
          // jQuery('.js-payment-method').val('skip');
          // jQuery('#ma-payment-method-cc').removeClass('is-active');
          jQuery('.payment-already-processed-block').removeClass('hidden-block');
          jQuery('.plan-change-block, .member-info-block').addClass('hidden-block');
          jQuery('#ma-payment-method-cc').find('#payment_cc_number,#payment_cc_code,#payment_cc_exp_month,#payment_cc_exp_year').prop('required', false);
          paymentProcessed = true;
          if (callback != null) {
            callback();
          }
          jQuery('#ma-continue').addClass('hidden-block');
          jQuery('#ma-member-form .form-actions .button-continue').removeClass('is-loading');
          return false;
        } else {
          jQuery('#ma-member-info').removeClass('hidden-block');
          jQuery('#ma-additional').removeClass('hidden-block');
          jQuery('#ma-additional *[data-required]').prop('required', true);
          jQuery('.payment-already-processed-block').addClass('hidden-block');
          jQuery('.plan-change-block, .member-info-block').removeClass('hidden-block');
          jQuery('#ma-continue').removeClass('hidden-block');
        }
        if (callback != null) {
          callback(response);
        }
        if (!paymentProcessed) {
          jQuery('#ma-member .section-subtitle').removeClass('hidden-block');
          jQuery('#ma-member-info').removeClass('hidden-block');

          var plan = jQuery('input[name="member[plan]"]').val();
          // remove Spouses for Associate membership plan
          if (plan && (plan.match(/\bassociate\b/i) || plan.match(/\bwinter\b/i))) {
            jQuery('#ma-additional').addClass('hidden-block').removeClass('is-active');
            jQuery('#ma-additional *[data-required]').prop('required', false);
            jQuery('#ma-charging-account').addClass('hidden-block');
            jQuery('#ma-charging-account input:first').prop('required', false);
          } else {
            if ($('#ma-member-info:visible').length) {
              jQuery('#ma-additional').removeClass('hidden-block');
              jQuery('#ma-additional *[data-required]').prop('required', true);
              changeAdditionalInfo($('.js-has-additional:checked').val() == 1); 
            }
            jQuery('#ma-charging-account').removeClass('hidden-block');
            jQuery('#ma-charging-account input:first').prop('required', true);
          }

          jQuery('#ma-member-form .form-actions .button').prop('disabled', false);
        }
      } else {
        swal(
          'Member not found',
          'The Member ID and Zip Code combination was not found in our database. Please check and try again.',
          'error'
        );
      }
      jQuery('#ma-member-form .form-actions .button-continue').removeClass('is-loading');

      // check if membership is actually disabled and not available anymore
      if (response && response.plan) {
        if (!response.plan.is_active && !response.plan.is_office) {
          $('#ma-member-info').addClass('hidden-block');
          $('#ma-charging-account').addClass('hidden-block');
          $('#ma-additional').addClass('hidden-block');
          $('#ma-change-plan').addClass('hidden-block');
          $('#ma-continue .button-continue').attr('disabled', 'disabled');
          $('#ma-sold-out').removeClass('hidden-block');
        } else {
          $('#ma-continue .button-continue').removeAttr('disabled');
          $('#ma-sold-out').addClass('hidden-block');
          $('#ma-change-plan').removeClass('hidden-block');
        }  
      }
    }).error(function (response, exception) {
      console.log(exception);
      swal(
        'Member not found',
        'The Member ID and Zip Code combination was not found in our database. Please check and try again.',
        'error'
      );
      console.log(response);
      jQuery('#ma-member-form .form-actions .button-continue').removeClass('is-loading');
    });
  }
  jQuery('#renewal_member_id,#renewal_member_zipcode').on('keyup', function () {
    validateRenewalInfo();
  });
  jQuery('#renewal_member_id,#renewal_member_zipcode').on('change', function () {
    validateRenewalInfo();
  });
  var updatePlan = () => {
    var planID = planIsBusiness ? 'biz' : 'all';
    this.setState({
      id: jQuery('input[name="member[plan_nid]"]').val(),
      title: jQuery('input[name="member[plan]"]').val(),
    });
    // Show
    jQuery("[class^='show-on-plan-'],[class*=' show-on-plan-']").addClass('hidden-block');
    jQuery("[class^='show-on-plan-'],[class*=' show-on-plan-']").find('[data-required]').prop('required', false);
    jQuery("[class^='show-on-plan-'],[class*=' show-on-plan-']").find('[data-disabled]').prop('disabled', true);
    jQuery('.show-on-plan-' + planID).removeClass('hidden-block');
    jQuery('.show-on-plan-' + planID).find(':not(.hidden-block) [data-required]').prop('required', true);
    jQuery('.show-on-plan-' + planID).find('[data-disabled]').prop('disabled', false);
    // Hide
    jQuery("[class^='hide-on-plan-'],[class*=' hide-on-plan-']").removeClass('hidden-block');
    jQuery("[class^='hide-on-plan-'],[class*=' hide-on-plan-']").find(':not(.hidden-block) [data-required]').prop('required', true);
    jQuery("[class^='hide-on-plan-'],[class*=' hide-on-plan-']").find('[data-disabled]').prop('disabled', false);
    jQuery('.hide-on-plan-' + planID).addClass('hidden-block');
    jQuery('.hide-on-plan-' + planID).find('[data-required]').prop('required', false);
    jQuery('.hide-on-plan-' + planID).find('[data-disabled]').prop('disabled', true);
    if (planIsBusiness) {
      for (var i = 0; i < 14; i++) {
        addAdditional();
      }
    }
    var plan = jQuery('input[name="member[plan]"]').val();
    // remove Spouses for Associate membership plan
    if (plan && (plan.match(/\bassociate\b/i) || plan.match(/\bwinter\b/i))) {
      jQuery('#ma-additional').addClass('hidden-block').removeClass('is-active');
      jQuery('#ma-additional *[data-required]').prop('required', false);
      // hide Charging Account
      jQuery('#ma-charging-account').addClass('hidden-block').removeClass('is-active');
      jQuery('#ma-charging-account *[data-required]').prop('required', false);
    } else if ($('#ma-member-info:visible').length) {
      jQuery('#ma-additional').removeClass('hidden-block').addClass('is-active');
      jQuery('#ma-additional *[data-required]').prop('required', true);
      changeAdditionalInfo($('.js-has-additional:checked').val() == 1); 
    }

    // remove Home Club for Single membership
    if (plan && plan.toLowerCase().match(/\bsingle\b/)) {
      $('#ma-home-club').hide();
      $('#ma-home-club input').removeAttr('required');
    } else {
      $('#ma-home-club').show();
      $('#ma-home-club input:first').prop('required', true);
    }

    // activate date of birth for ALL
    // if (plan && plan.toLowerCase().match(/\byoung pro/)) {
      $('#ma-date-of-birth').removeClass('hidden-block');
      $('#ma-date-of-birth select').prop('required', true);
    // } else {
    //   $('#ma-date-of-birth').addClass('hidden-block');
    //   $('#ma-date-of-birth select').prop('required', false);
    // }
  }
  // Update Plan Price
  var updatePlanPrice = () => {
    var that = this;
    var plan_id = jQuery('[name="member[plan_nid]"]').val();
    const tax_rate = this.state.tax_rate / 100;
    // var is250 = false;
    // if ($member_id && $member_id.val() && ['24', '25'].indexOf(plan_id) !== -1) { // && $member_zipcode.val() === '00000') {
    //     is250 = true;
    // }
    subtotalPrice = planPrice;
    var discount = 0;
    if (discountsPrice > 0) {
      discount = discountsPrice;
    } 
    // checked Existing Member
    if (isExistingMember && !discountsPrice && renewal_discount) {
      discount = renewal_discount;
    }
    // else if (is250) {
    //   discount = 250;
    // }
    if (discount > 0) {
      subtotalPrice -= discount;
    }
    // if (planIsBusiness) {
    //   subtotalPrice += additionalMembersPrice;
    // }

    // calculate current plan total price without additional spouse/children, because those might have different taxable amounts
    finalPrice = subtotalPrice + (this.state.taxable_amount / 100) * subtotalPrice * tax_rate;

    // Additionals
    var additionalsEnabled = jQuery('#additional_yes').is(':checked');
    if (additionalsEnabled && !planIsBusiness) {
      // if (additionalsCount > 0) {
      //   // use default additionals price or the one with plan discount
      //   var additionals = jQuery('.additionals-table .additionals-row:visible');
      //   additionals.each(function() {
      //     if ($(this).find('select.adt-relationship').val() === 'child') {
      //       subtotalPrice += that.state.additional_children_price;
      //       finalPrice += that.state.additional_children_price + (that.state.additional_children_taxable_amount / 100) * that.state.additional_children_price * tax_rate;
      //     } else if ($(this).find('select.adt-relationship').val() === 'spouse') {
      //       subtotalPrice += that.state.additional_spouse_price;
      //       finalPrice += that.state.additional_spouse_price + (that.state.additional_spouse_taxable_amount / 100) * that.state.additional_spouse_price * tax_rate;
      //     }
      //   });
      // }
    }

    // Spouse or child Member Access Option
    var additionalsAccessOption = jQuery('#additional_yes').is(':checked');
    if (additionalsAccessOption) {
      if ($('.js-additional-access-option:checked').val() === 'option_1') {
        subtotalPrice += 3059.63 / 1.01987667;
        finalPrice += 3059.63;
      } else if ($('.js-additional-access-option:checked').val() === 'option_2') {
        subtotalPrice += 1019.88 / 1.01988;
        finalPrice += 1019.88;
      }
    }

    if ($('.js-cart-pass:checked').val() === '1' && !before121) {
      subtotalPrice += 1000;
      finalPrice += 1000 * 1.06625;
    }

    var labelFinalPrice = '$' + numberWithCommas(round(finalPrice)) + ' <small>(tax included)</small>';
    var labelSplitPrice = '$' + numberWithCommas(round(finalPrice)) + ' <small>(tax included)</small>';
    if (discount > 0) {
      var auxFinalPrice = finalPrice + discount;
      var auxDiscount = discount;
      labelFinalPrice = '<del>$' + numberWithCommas(round(auxFinalPrice)) + '</del> / <span class="red">$' + numberWithCommas(round(finalPrice)) + '</span> <small>(includes $' + numberWithCommas(round(auxDiscount)) + ' discount and taxes)</small>';
      labelSplitPrice = '<del>$' + numberWithCommas(round(auxFinalPrice)) + '</del> / <span class="red">$' + numberWithCommas(round(finalPrice)) + '</span> <small>(includes $' + numberWithCommas(round(auxDiscount)) + ' discount and taxes)</small>';
    }

    finalPrice = round(finalPrice);
    this.setState({
      final_price: finalPrice
    });
    jQuery('.plan-price').html(labelFinalPrice);
    jQuery('#ma-member .plan-price').html(labelSplitPrice);
  }
  // Validation Defaults
  jQuery.validator.setDefaults({
    highlight: function (element, errorClass, validClass) {
      jQuery(element).parents(".form-group").addClass("has-error").removeClass("has-success");
    },
    unhighlight: function (element, errorClass, validClass) {
      jQuery(element).parents(".form-group").addClass("has-success").removeClass("has-error");
    }
  });
  // Validation Settings for Member Info Fields
  validators['memberForm'] = jQuery('#ma-member-form').validate({
    messages: {
      // Add custom error messages
      // Ex.: "member[first_name]": "Test message",
    }
  });
  // Validation Settings for Payment Info Fields
  validators['paymentForm'] = jQuery('#ma-payment-form').validate({
    rules: {
      "payment[cc_number]": {
        creditcard: true
      },
      "payment[charging_account][cc_number]": {
        creditcard: true
      },
      "payment[monthly_payments][cc_number]": {
        creditcard: true
      }
    },
    messages: {
      // Add custom error messages
    }
  });
  // Validation Settings for Terms Acceptance Fields
  validators['termsAcceptanceForm'] = jQuery('#ma-terms-acceptance-form').validate({
    messages: {
      // Add custom error messages
    }
  });
  jQuery('#payment_cc_exp_month').on('change', function () {
    var date = new Date();
    if (parseInt(jQuery(this).val()) <= (date.getMonth() + 1)) {
      var yearSelect = jQuery('#payment_cc_exp_year');
      var yearOption = yearSelect.find('option[value="' + date.getFullYear() + '"]');
      if (yearOption.is('selected')) {
        yearSelect.val(date.getFullYear() + 1);
        yearSelect.change();
      }
      yearOption.prop('disable', true);
      yearOption.hide();
    } else {
      var yearSelect = jQuery('#payment_cc_exp_year');
      var yearOption = yearSelect.find('option[value="' + date.getFullYear() + '"]');
      yearOption.prop('disable', false);
      yearOption.show();
    }
  });
  jQuery('#payment_charging_account_cc_exp_month').on('change', function () {
    var date = new Date();
    if (parseInt(jQuery(this).val()) <= (date.getMonth() + 1)) {
      var yearSelect = jQuery('#payment_charging_account_cc_exp_year');
      var yearOption = yearSelect.find('option[value="' + date.getFullYear() + '"]');
      if (yearOption.is('selected')) {
        yearSelect.val(date.getFullYear() + 1);
        yearSelect.change();
      }
      yearOption.prop('disable', true);
      yearOption.hide();
    } else {
      var yearSelect = jQuery('#payment_charging_account_cc_exp_year');
      var yearOption = yearSelect.find('option[value="' + date.getFullYear() + '"]');
      yearOption.prop('disable', false);
      yearOption.show();
    }
  });
  jQuery('.js-change-plan-toggle').on('click', function (e) {
    e.preventDefault();
    jQuery('.js-change-plan-wrapper').toggleClass('hidden-block');
    if (jQuery('.js-change-plan-wrapper').hasClass('hidden-block')) {
      jQuery('.js-change-plan-toggle').html('Change Plan');
    } else {
      jQuery('.js-change-plan-toggle').html('Cancel');
    }
    return false;
  });
  jQuery('.js-change-plan').on('click', (e) => {
    e.preventDefault();
    if (!jQuery('.js-change-plan-select').val()) {
      return false;
    }
    swal({
      title: 'Do you confirm your change of plan?',
      type: 'question',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        $member_id = jQuery('#renewal_member_id');
        $member_zipcode = jQuery('#renewal_member_zipcode');
        if ($member_id.val().length == 5 && $member_zipcode.val().length == 5) {
          loadMemberInfo($member_id.val(), $member_zipcode.val(), (response) => {
            var $select = jQuery('.js-change-plan-select');
            var $option = $select.find('option:selected');
            jQuery('[name="member[plan_nid]"]').val($option.data('id'));
            jQuery('[name="member[plan]"]').val($option.data('name'));
            updatePlan();
            jQuery('.plan-name').html($option.data('name'));
            let selected_plan_id = parseInt($option.data('id'));
            if (response.pid === selected_plan_id && response.plan) {
              planPrice = parseFloat(response.plan.price);
              discountsPrice = parseFloat(response.plan.discounts_price);
            } else if (response.tenured_prices && response.tenured_prices[selected_plan_id]) {
              planPrice = parseFloat(response.tenured_prices[selected_plan_id].price);
              discountsPrice = parseFloat(response.tenured_prices[selected_plan_id].discounts_price);
            } else {
              planPrice = parseFloat($option.data('price'));
              discountsPrice = parseFloat($option.data('discount'));  
            }
            this.setState({
              taxable_amount: $option.data('taxable-amount')
            }, () => {
              updatePlanPrice();
              jQuery('.js-change-plan-toggle').click();  
            });
          });
        }
      }
    });
    return false;
  });
  updatePlan();
  updatePlanPrice();

  // preloaded member ID and zipcode
  if (jQuery('#renewal_member_id').val()) {
    validateRenewalInfo();
  }
};

class Membership extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // finalPrice: props.planPrice
      planPrice: props.price,
      final_price: 0,
      total_price: props.price,
      member_loaded: false,
      id: props.id,
      title: props.title,
      tax_rate: props.tax_rate,
      taxable_amount: props.taxable_amount,
      additional_spouse_price: props.additional_spouse_price,
      additional_children_price: props.additional_children_price,
      additional_spouse_taxable_amount: props.additional_spouse_taxable_amount,
      additional_children_taxable_amount: props.additional_children_taxable_amount,
      require_same_credit_card_checkbox: false
    };
    apiKey = props.api_key;
    planPrice = props.price;
    subtotalPrice = planPrice;
    finalPrice = planPrice;
    memberHash = 'OG-' + Math.random().toString(36).substring(2, 10).toUpperCase();
    nodeURL = props.url;
    renewal_period = props.renewal_period;
    renewal_discount = props.renewal_discount;
  }

  /**
   * Initial member and payment form bootstrap
   */
  componentDidMount = () => {
    setTimeout(() => {
      init.call(this);

      $(window).on("pageshow", (event) => {
        if (event && event.originalEvent.persisted) {
          init.call(this);
        }
      });

      document.addEventListener('DOMContentLoaded', () => {
        var ibackbutton = document.getElementById("backbuttonstate");

        setTimeout(() => {
          if (ibackbutton.value == "0") {
            // Page has been loaded for the first time - Set marker
            ibackbutton.value = "1";
          } else {
            // Back button has been fired.. Do Something different..
            init.call(this);
          }
        }, 200);
      }, false);
    }, 200);
  }

  /**
   * Final step in the payment process,
   * sending over to Woocommerce
   */
  sendMembershipData = () => {
    
    var simplified = {};
    for (var i = 0; i < membershipData.length; i++) {
      simplified[membershipData[i].name] = membershipData[i].value;
    }
    
    // important Woocommerce fields
    var billing = $('.woocommerce-billing-fields');
    billing.find('*[name="billing_first_name"]').val(simplified['member[first_name]']);
    billing.find('*[name="billing_last_name"]').val(simplified['member[last_name]']);
    // billing.find('*[name="billing_company"]').val(simplified['member[company]']);
    billing.find('*[name="billing_address_1"]').val(simplified['member[address]']);
    billing.find('*[name="billing_country"]').val('US');
    billing.find('*[name="billing_city"]').val(simplified['member[city]']);
    billing.find('*[name="billing_state"]').val(simplified['member[state]']);
    billing.find('*[name="billing_postcode"]').val(simplified['member[zipcode]']);
    billing.find('*[name="billing_phone"]').val(simplified['member[phone]']);
    billing.find('*[name="billing_email"]').val(simplified['member[email]']);

    // make sure <select> boxes still have values
    $('<input type="hidden" name="billing_state" />').val(simplified['member[state]']).appendTo(billing);
    
    // raw data
    $('<input type="hidden" name="membership_data" />').val(JSON.stringify(simplified)).appendTo(billing);

    // remove continue buttons
    jQuery('#ma-continue').remove();

    jQuery('#ma-payment').closest('form').submit();
  }

  checkValidity = (form, validator) => {
    var valid = true;
    if ($('#ma-member-renewal-info').is(':visible') && !this.state.member_loaded) {
      valid = false;
    }
    form.find(':input:not(button):not([type="hidden"])').each(function() {
      if (validators[validator] && !validators[validator].element(this)) {
        valid = false;
      }
    });
    return valid;
  }

  onSubmitMember = () => {
    var memberForm = $('#ma-member-form');
    // log('valid: ' + memberForm[0].checkValidity() + ', captcha: ' + captchaExecuted + ', isDone: ' + isDone);
    // console.log(memberForm, validators);
    if (this.checkValidity(memberForm, 'memberForm')) {
      if (!captchaExecuted) {
        grecaptcha.execute(); // execute() will run onSubmitMemberForm when it's done
      } else {
        // important total_price to transfer it to PaymentForm
        this.setState({
          total_price: finalPrice
        });
        onSubmitMemberForm();
      }
    }
    return false;
  }

  onSubmitPayment = () => {
    var paymentForm = jQuery('#ma-payment-form');
    var $paymentMethod = jQuery('.js-payment-method');
    if (!this.checkValidity(paymentForm, 'paymentForm')) {
      return false;
    }

    if (signaturePad.isEmpty()) {
      swal(
        'Error',
        'Please enter your signature.',
        'error'
      );
      return false;
    }
    
    if (($paymentMethod.length == 1 && ($paymentMethod.val() == 'credit_card' || $paymentMethod.val() == 'check')) ||
      ($paymentMethod.length == 2 && (jQuery('.js-payment-method:checked').val() == 'credit_card') || jQuery('.js-payment-method:checked').val() == 'check')) {
      if (!paymentProcessed) {
        jQuery('#ma-payment-form .button-continue').addClass('is-loading');
        jQuery('#ma-payment-form .button-continue').prop('disabled', true);
        jQuery('#ma-payment-form .button-back').prop('disabled', true);
        var $paymentMethod = jQuery('.js-payment-method');
        var $creditCardNumber = jQuery('#payment_cc_number');
        var $creditCardExpMonth = jQuery('#payment_cc_exp_month');
        var $creditCardExpYear = jQuery('#payment_cc_exp_year');
        var $creditCardCode = jQuery('#payment_cc_code');
        var billingFullName = jQuery('#member_first_name').val() + ' ' +
          jQuery('#member_middle_name').val() + ' ' +
          jQuery('#member_last_name').val();
        var $billingAddress = jQuery('#member_address');
        var $billingZipCode = jQuery('#member_zipcode');
        var usesDifferentInfo = jQuery('#payment_different_info').is(':checked');
        if (usesDifferentInfo) {
          billingFullName = jQuery('#payment_billing_info_first_name').val() + ' ' +
            jQuery('#payment_billing_info_middle_name').val() + ' ' +
            jQuery('#payment_billing_info_last_name').val();
          $billingAddress = jQuery('#payment_billing_info_address');
          $billingZipCode = jQuery('#payment_billing_info_zipcode');
        }
        var paymentInfo = {
          token: apiToken,
          name: billingFullName + ' CC',
          properties: {
            nameOnCard: billingFullName,
            cardNumber: $creditCardNumber.val(),
            expirationDate: $creditCardExpMonth.val() + '/' + $creditCardExpYear.val(),
            cvv: $creditCardCode.val(),
          },
          billingAddress: {
            addressLine1: $billingAddress.val(),
            postalCode: $billingZipCode.val()
          }
        };
        log('performing payment request for ' + billingFullName + ' - zip ' + $billingZipCode.val());
        processPayment({});
        this.sendMembershipData();
        // jQuery.ajax({
        //   url: apiURL + "?dt=" + new Date().getTime(),
        //   method: 'post',
        //   dataType: "json",
        //   contentType: "application/json",
        //   crossDomain: true,
        //   data: JSON.stringify({
        //     createPaymentInstrument: {
        //       createPaymentInstrumentRequest: paymentInfo
        //     }
        //   })
        // }).success((response) => {
        //   log('success response: ' + JSON.stringify(response));
        //   if (response.createPaymentInstrumentResponse) {
        //     // Chargin Account Validation
        //     // if (jQuery('#payment_charging_account_different_info').is(':checked')) {
        //     //     validateChargingAccount(response);
        //     // } else {
        //     processPayment(response).always(() => {
        //       if (paymentProcessed) {
        //         this.sendMembershipData();
        //       }
        //     });
        //     // }
        //   }
        // }).error((response) => {
        //   log('error response: ' + JSON.stringify(response));
        //   showError(response, 'payment');
        //   jQuery('#ma-payment-form .button-continue').removeClass('is-loading');
        //   jQuery('#ma-payment-form .button-continue').prop('disabled', false);
        //   jQuery('#ma-payment-form .button-back').prop('disabled', false);
        //   if (response && response.responseJSON && response.responseJSON.error && response.responseJSON.error.description && response.responseJSON.error.description.match('session ID')) {
        //     // re-initialize the session
        //     initApiToken(); // reinitialize API token
        //   }
        // });
      } else {
        membershipData = jQuery('#ma-member-form').closest('form').serializeArray();
        membershipData.push({
          name: 'payment[transactionId]',
          value: transactionId
        });
        membershipData.push({
          name: 'payment[correlationId]',
          value: correlationId
        });
        membershipData.push({
          name: 'payment[approvalCode]',
          value: approvalCode
        });
        membershipData.push({
          name: 'member[plan_price_notax]',
          value: subtotalPrice
        });
        membershipData.push({
          name: 'member[plan_price]',
          value: finalPrice
        });
        membershipData.push({
          name: 'member[signature]',
          value: signaturePad.toDataURL()
        });
        membershipData.push({
          name: 'member[hash]',
          value: memberHash
        });
        log('payment processed, submitting data to step two: ' + JSON.stringify(membershipData));
        isDone = true;
        this.sendMembershipData();
      }
    } else {
      membershipData = jQuery('#ma-member-form').closest('form').serializeArray();
      membershipData.push({
        name: 'member[plan_price_notax]',
        value: subtotalPrice
      });
      membershipData.push({
        name: 'member[plan_price]',
        value: finalPrice
      });
      membershipData.push({
        name: 'member[signature]',
        value: signaturePad.toDataURL()
      });
      log('instantly submitting data to step two, payment type ' + jQuery('.js-payment-method:checked').val() + ': ' + JSON.stringify(membershipData));
      
      isDone = true;
      this.sendMembershipData();
    }
    return false;
  }

  render() {
    const props = this.props;
    const state = this.state;
    const plan_title = props.title;
    const plan_price = this.state.planPrice; // props.price;
    const renewal = props.renewal;
    const plan_is_available_for_purchase = props.plan_is_available_for_purchase;
    const member_loaded = state.member_loaded;
    
    if (!renewal && !plan_is_available_for_purchase) {
      return <div>
        <div className="membership-app-section is-active" id="ma-member">
          <h2 className="section-title">Membership {renewal ? 'Renewal' : 'Application'}</h2>
          <h3 className="section-subtitle">
              <strong className="plan-name">{plan_title}</strong> - <span className="plan-price">${plan_price}</span>
          </h3>
        </div>
        <h3 className="text-center"><strong>Sorry, membership is all sold out!</strong></h3>
      </div>;
    }

    return <div>
      <input id="backbuttonstate" type="text" defaultValue="0" style={{ display: "none" }} />
      <MemberForm 
        renewal={props.renewal} 
        memberLoaded={member_loaded}
        id={state.id} 
        title={state.title}
        price={plan_price}
        plans={props.plans}
        final_price={this.state.final_price}
        allow_cart_pass={props.allow_cart_pass}
        preselected_cart_pass={props.preselected_cart_pass}
        home_club={props.home_club}
        allow_monthly_payments={props.allow_monthly_payments}
        before121={before121}
        is_existing_member={isExistingMember}
        onSubmit={this.onSubmitMember}
        />
      <PaymentForm 
        id={state.id}
        renewal={props.renewal}
        title={state.title}
        price={state.total_price}
        final_price={state.final_price} 
        is_admin={props.is_admin} 
        terms_and_conditions={props.terms_and_conditions} 
        charging_account_terms_and_conditions={props.charging_account_terms_and_conditions}
        require_same_credit_card_checkbox={state.require_same_credit_card_checkbox}
        onSubmit={this.onSubmitPayment}
        slug={props.slug}
        />
    </div>
  }
}

/**
 * Main start point
 */
if ($('#membership-container').length) {
  var container = $('#membership-container');
  var props = container.data('app');
  const root = ReactDOMClient.createRoot(container[0]);
  root.render(<Membership {...props} />);
}
